import type { NavigationLink } from "../types";
import DropdownHighlight from "./DropdownHighlight";

export default function ReferenceDropdown({
  link,
  locale,
}: {
  link: NavigationLink;
  locale?: string;
}) {
  if (!link || !link.highlight?.length) return null;

  return (
    <ul className="col-span-full mx-auto grid max-w-7xl auto-cols-fr grid-flow-col gap-x-4 p-4">
      {link.highlight.map(
        (highlight, index) =>
          highlight && (
            <li key={`${highlight.slug ?? "highlight"}-${index}`}>
              <DropdownHighlight item={highlight} locale={locale} />
            </li>
          ),
      )}
    </ul>
  );
}
